import { render, staticRenderFns } from "./TeacherSpecializeFormView.vue?vue&type=template&id=c9ebdb1e&scoped=true"
import script from "./TeacherSpecializeFormView.vue?vue&type=script&lang=js"
export * from "./TeacherSpecializeFormView.vue?vue&type=script&lang=js"
import style0 from "./TeacherSpecializeFormView.vue?vue&type=style&index=0&id=c9ebdb1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9ebdb1e",
  null
  
)

export default component.exports